module.exports = __webpack_public_path__ + "static/media/angela.59a73f00.svg";